export default {
  "pwaNotificationTasks.thead.no": "#NO",
  "pwaNotificationTasks.thead.taskId": "TaskId",
  "pwaNotificationTasks.thead.title": "Title",
  "pwaNotificationTasks.thead.content": "Content",
  "pwaNotificationTasks.thead.url": "Url",
  "pwaNotificationTasks.thead.createTime": "CreateTime",
  "pwaNotificationTasks.title": "PWA Notification Tasks",
  "pwaNotificationTasks.action.details": "Details",
  "pwaNotificationTasks.modal.title.details": "Task Details",
  "pwaNotificationTasks.message.copySuccess": "Copy Success!",
};